import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import { localesList, i18n } from '@/i18n'

Vue.use(Router)

if ('scrollRestoration' in history) {
  // Back off, browser, I got this...
  history.scrollRestoration = 'manual'
}

// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior = function (to, from, savedPosition) {
  return new Promise(resolve => {
    // wait for the out transition to complete (if necessary)
    this.app.$root.$once('triggerScroll', () => {
      // if the resolved position is falsy or an empty object,
      // will retain current scroll position.
      resolve({ x: 0, y: 0 })
    })
  })
}

const regexpLang = `(${localesList.join('|')})`

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior,
  routes: [
    {
      path: '/',
      redirect: '/en'
    },
    {
      path: `/:lang${regexpLang}`,
      name: 'home',
      component: Home
    },
    {
      path: `/:lang${regexpLang}/job-offers`,
      name: 'job-offers',
      alias: '/:lang(fr)/offres-emplois',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "job-offers" */ './views/JobOffers.vue'),
      // https://router.vuejs.org/guide/essentials/passing-props.html#object-mode
      props: (route) => ({ query: route.query })
    },
    {
      path: `/:lang${regexpLang}/job-offers/details`,
      name: 'job-offers-details',
      alias: '/:lang(fr)/offres-emplois/details',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "job-offers-details" */ './views/JobOffersDetails.vue'),
      // https://router.vuejs.org/guide/essentials/passing-props.html#object-mode
      props: (route) => ({ id: route.query.nPostingTargetID })
    },
    {
      path: `/:lang${regexpLang}/unsubscribe`,
      name: 'unsubscribe',
      alias: '/:lang(fr)/desinscription',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "unsubscribe" */ './views/PageUnsubscribe.vue'),
      // https://router.vuejs.org/guide/essentials/passing-props.html#object-mode
      props: (route) => ({ sTechnicalID: route.query.sTechnicalID }),
      beforeEnter: (to, from, next) => {
        if (to.query.sTechnicalID) {
          next()
        } else {
          // redirect to the homepage in case of missing sTechnicalID parameter
          next({ name: 'home', replace: true, params: to.params })
        }
      }
    },
    {
      path: '*',
      redirect: '/en'
    }
  ]
})

router.beforeEach((to, from, next) => {
  i18n.locale = to.params.lang
  // naive approach to update title / description
  // for a more complex implementation please consider using
  // https://vue-meta.nuxtjs.org/
  try {
    document.title = i18n.t('meta_title')
    document.querySelector('meta[name="description"]')
      .setAttribute('content', i18n.t('meta_description'))
    document.querySelector('html')
      .setAttribute('lang', to.params.lang)
  } catch (error) {
    console.warn(error)
  }
  next()
})

export default router
